// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var kindSchema = S.union([
      S.literal("Bucket"),
      S.literal("Chain")
    ]);

var Sig = {
  name: "V3ClozeDndStyleContext"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Sig);

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var use = include.use;

export {
  kindSchema ,
  Sig ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
}
/* kindSchema Not a pure module */
